import { debug as debugLib } from "debug";

export const debug = debugLib("lc");
